import { useUser } from "@/hooks/use-user";
import { PosOrderProvider } from "@/hooks/pos/use-order";
import OrderHistory from "@/components/pos/order-history";
import { useLocation } from "wouter";
import { Loader2 } from "lucide-react";

export default function OrderHistoryPage() {
	const [, navigate] = useLocation();
	const { uid, loading } = useUser();

	if (loading) {
		return (
			<div className="min-h-screen bg-[var(--pos-primary-background-color)] flex items-center justify-center">
				<Loader2 className="h-6 w-6 animate-spin text-gray-400" />
			</div>
		);
	}

	return (
		<div className="bg-[var(--pos-secondary-background-color)] min-h-screen">
			<PosOrderProvider userId={uid!}>
				<OrderHistory onBackToLocation={() => navigate("/order")} />
			</PosOrderProvider>
		</div>
	);
}
